export const ChanelConfig = {
  TickChanel: 'Realtime.Tick',
  HeatMapChanelPrefix: 'Market.HeatMap',
  IndexChannel: 'Realtime.Index',
  WatchListChannel: 'Realtime.WatchList',
  PerformanceChannel: 'Realtime.Performance',
  BidAskChannel: 'Realtime.BidAsk',
  DerivativeChannel: 'Realtime.Derivative',
  OtherLoginChannel: 'Realtime.UserLogin',
  CoveredWarrantChannel: 'Realtime.CoveredWarrant',
};

export const StoreNames = {
  Tickers: 'Tickers',
  Exchanges: 'Exchanges',
  Sectors: 'Sectors',
};

export const TimeReloadOnFocusBlur = {
  TimeIntervalReloadData: 337000,
};
